export default {
  validation: {
    VALIDATION: 'Validation',
    INVALID: 'Import invalide',
    INVALID_EMPLOYEEID: `Numéro d'employé invalide`,
    INVALID_DATE: `Date invalide`,
    INVALID_END_DATE: `Date de fin invalide`,
    INVALID_START_DATE: `Date de début invalide`,
    INVALID_RANGE: `Plage horaire invalide`,
    END_DATE_BEFORE_START_DATE: `Date de fin antérieure à date de début`,
    START_IN_PAST: `Date de début dans le passé`,
    INVALID_TIME: `Heure invalide`,
    INVALID_START_TIME: 'Heure de début invalide',
    INVALID_END_TIME: 'Heure de fin invalide',
    INVALID_REQUEST_TYPE: 'Type de requête invalide',
    INVALID_CODE: "Code d'import invalide",
    INVALID_STATUS: 'Statut invalide',
    CODE_NOT_UNIQUE: `Code non unique`,
    INVALID_DEPARTMENTS: `Codes de départements invalides`,
    INVALID_POSITIONS: `Codes de positions invalides`,
    INVALID_POSITION_CODE: `Code de position invalide`,
    INVALID_PROJECT_CODE: `Code de projet invalide`,
    INVALID_REQUIRED_POSITIONS: `Codes de positions requises invalides`,
    INVALID_LOCKEDUSERS: `Numéros d'employés verrouillés invalides`,
    INVALID_PREFERREDUSERS: `Numéros d'employés préférés invalides`,
    INVALID_BLOCKEDUSERS: `Numéros d'employés bloqués invalides`,
    INVALID_REQUIREDATTRIBUTES: `Codes d'attributs requis invalides`,
    INVALID_PREFERREDATTRIBUTES: `Codes d'attributs préférés invalides`,
    INVALID_TAGS: `Codes d'étiquettes invalides`,
    INVALID_WAGEPREMIUMS: `Codes de primes invalides`,
    INVALID_POSITION_FOR_PROJECT: `Position non requise pour le projet`,
    INVALID_DEFAULT_SHIFT_TAGS: `Codes d'étiquettes de quart par défaut invalides`
  }
}
